<template>
  <mrc_ess_skeleton_loader :loading="skLoading">
    <v-card>
      <mrc_ess_iconGroup
        style="top: -50px"
        v-show="disabled"
        v-if="$store.state.uuid"
        @handleReturn="handleReturn"
        :showEdit="hasBtn('edit-function')"
        :show_del="hasBtn('delete-function')"
        @handleEdit="handleEdit"
        @handleDel="handleDel"
      ></mrc_ess_iconGroup>
      <v-card-text>
        <v-row>
          <v-col cols="auto" v-if="detailData.uuid">
            <!-- :label="
                detailData.status_uuid
                  ? $t('label_To_enable_the')
                  : $t('label_disable')
              " -->
            <mrc_ess_switch
              v-model="detailData.status_uuid"
              trueValue="1"
              falseValue="0"
              color="primary"
              :readonly="disabled"
            ></mrc_ess_switch>
          </v-col>
        </v-row>
        <v-form ref="add_func">
          <v-row>
            <!-- 功能名称 -->
            <v-col cols="12" sm="6">
              <mrc_ess_multiText
                :label="$t('label_The_name_of_the_function') + '*'"
                style="width: 100%"
                :isNational="judegNational('function_name')"
                v-model="detailData.function_name"
                append-icon="mdi-longitude"
                :error-messages="
                  $errors('detailData', 'function_name', requiredRule)
                "
                :readonly="disabled"
              >
              </mrc_ess_multiText>
            </v-col>
            <!-- 短编码 -->
            <v-col cols="12" sm="6">
              <mrc_ess_multiText
                :readonly="disabled"
                style="width: 100%"
                required
                :label="$t('label_Function_short_code') + '*'"
                :isNational="judegNational('function_shortcode')"
                v-model="detailData.function_shortcode"
                :error-messages="
                  $errors('detailData', 'function_shortcode', requiredRule)
                "
                append-icon="mdi-longitude"
              >
              </mrc_ess_multiText>
            </v-col>
            <!-- 描述 -->
            <v-col cols="12" sm="12">
              <mrc_ess_multiText
                :readonly="disabled"
                style="width: 100%"
                required
                :label="$t('label_Functional_description') + '*'"
                :isNational="judegNational('function_description')"
                :error-messages="
                  $errors('detailData', 'function_description', requiredRule)
                "
                v-model="detailData.function_description"
              >
              </mrc_ess_multiText>
            </v-col>
            <!-- 上级模块 -->
            <v-col cols="12" sm="6">
              <!-- :disabled="$store.state.uuid.length > 0" -->
              <!-- <mrc_ess_prompt
                :select_arr="top_module"
                :label="$t('label_The_superior_module') + '*'"
                item-text="view_fields"
                item-value="value_field"
                :disabled="disabled"
                @getData="moduleChange"
                :errMsg="$errors('detailData', 'module_uuid', requiredRule)"
                v-model="detailData.module_uuid"
              ></mrc_ess_prompt> -->
              <mrc_ess_autoComplete
                :label="$t('label_The_superior_module') + '*'"
                :readonly="disabled"
                moduleView
                @changeStaff="moduleChange"
                :error-messages="
                  $errors('detailData', 'module_uuid', requiredRule)
                "
                v-model="detailData.module_uuid"
                :dropDownList="top_module"
              >
              </mrc_ess_autoComplete>
            </v-col>
            <!-- 版本 -->
            <v-col cols="12" sm="6">
              <mrc_ess_prompt
                :obj="function_button_version"
                :label="$t('label_version') + '*'"
                item-text="view_fields"
                :no-data-text="$t('label_pleaseSelectModule')"
                item-value="value_field"
                :disabled="disabled"
                :errMsg="$errors('detailData', 'version_uuid', requiredRule)"
                v-model="detailData.version_uuid"
              ></mrc_ess_prompt>
              <!-- <mrc_ess_prompt
                :select_arr="version_arr"
                :label="$t('label_version') + '*'"
                v-if="!$store.state.uuid"
                item-text="view_fields"
                :no-data-text="$t('label_pleaseSelectModule')"
                item-value="value_field"
                :disabled="$store.state.uuid.length > 0"
                :errMsg="$errors('detailData', 'version_uuid', requiredRule)"
                v-model="detailData.version_uuid"
              ></mrc_ess_prompt> -->
              <!-- <mrc_ess_input
                v-else
                disabled
                :label="$t('label_version') + '*'"
                v-model="detailData.version_uuid"
                :rules="$text_rules($t('label_version'))"
              >
              </mrc_ess_input> -->
            </v-col>
            <v-col cols="12" sm="12">
              <!-- 关联数据表 -->
              <mrc_ess_prompt
                :select_arr="data_table"
                :label="$t('label_Associated_data_table') + '*'"
                item-text="view_fields"
                :errMsg="$errors('detailData', 'table_uuid', requiredRule)"
                item-value="value_field"
                :disabled="disabled"
                v-model="detailData.table_uuid"
              ></mrc_ess_prompt>
              <!-- :errMsg="$errors('detailData', 'table_uuid', requiredRule)" -->
              <!-- <v-select :readonly="disabled"
                        :items="data_table"
                        :label="$t('label_Associated_data_table') + '*'"
                        v-model="detailData.table_uuid"
                        :error-messages="$errors('detailData','table_uuid',requiredRule)"
                        item-text='view_fields'
                        item-value='value_field'
                        required
                        chips></v-select> -->
            </v-col>
            <v-col cols="12" sm="6">
              <!-- 客户端类型 -->
              <mrc_ess_prompt
                :select_arr="client_type"
                :label="$t('label_Client_type') + '*'"
                value_field="value_field"
                view_fields="view_fields"
                :disabled="disabled"
                multiple
                :no-data-text="$t('label_pleaseSelectModule')"
                :errMsg="
                  $errors('detailData', 'client_type_uuid', requiredRule)
                "
                v-model="detailData.client_type_uuid"
              ></mrc_ess_prompt>
              <!-- <v-select :readonly="disabled"
                        :label="$t('label_Client_type') + '*'"
                        v-model="detailData.client_type_uuid"
                        :error-messages="$errors('detailData','client_type_uuid',requiredRule)"
                        :items="client_type"
                        item-value="value_field"
                        item-text="view_fields"
                        required
                        no-data-text="请先选择上级模块"
                        chips
                        multiple></v-select> -->
            </v-col>
            <v-col cols="12" sm="6">
              <!-- <v-select :readonly="disabled"
                        :items="func_type"
                        :label="$t('label_Function_type') + '*'"
                        v-model="detailData.function_type_uuid"
                        item-text='dict_label'
                        item-value='dict_value'
                        required
                        chips
                        :rules="[v => !!v || $t('label_Function_type')]"></v-select> -->
              <mrc_ess_dictName
                v-model="detailData.function_type_uuid"
                :disabled="disabled"
                :label="$t('label_Function_type') + '*'"
                :placeholder="$t('label_Function_type')"
                :errMsg="
                  $errors('detailData', 'function_type_uuid', requiredRule)
                "
                :select_arr="func_type"
              ></mrc_ess_dictName>
            </v-col>

            <!-- <v-col cols="12" sm="12">
              <mrc_ess_autoComplete
                :label="$t('label_Only_for_the_following_units')"
                :readonly="disabled"
                orgView
                itemValue="uuid"
                multiple
                v-model="detailData.org_level_uuid"
                :dropDownList="unit_data"
              >
              </mrc_ess_autoComplete>
            </v-col> -->
          </v-row>
        </v-form>
      </v-card-text>
      <mrc_ess_submitBtn
        v-if="!disabled"
        :cancelText="$t('label_cancel')"
        :successText="successText"
        @cancel="cancel"
        @success="success"
      ></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  getBusinessList,
  get_func_add,
  get_versions,
  get_func_del,
} from "@/service/api/func_module";
import { getBusinessList as getprompt } from "@/service/api/prompt";
import { getDataByName } from "@/service/api/data_dictionary";
import { required } from "vuelidate/lib/validators";
// import iconGroup from '@/components/iconGroup'
export default {
  components: {},
  props: {
    func_data: {
      type: Object,
    },
    func_disabled: {
      type: Boolean,
    },
  },
  validations: {
    detailData: {
      function_name: {
        required,
      },
      function_shortcode: {
        required,
      },
      function_description: {
        required,
      },
      module_uuid: {
        required,
      },
      version_uuid: {
        required,
      },
      table_uuid: {
        required,
      },
      client_type_uuid: {
        required,
      },
      function_type_uuid: {
        required,
      },
      // org_level_uuid: {
      //   required
      // },
    },
  },
  data() {
    return {
      skLoading: true,
      successText: this.$t("label_The_next_step"),
      detailData: {
        function_name: "",
        function_shortcode: "",
        function_description: "",
        table_uuid: "",
        function_type_uuid: "",
        module_uuid: "",
        org_level_uuid: "", // 多选
        status_uuid: "1",
        client_type_uuid: [],
        version_uuid: "",
        uuid: null,
      },
      uuid: null,
      top_module: [],
      data_table: [],
      func_type: [],
      unit_data: [],
      version_arr: [],
      client_type: [],
      version_uuid: "",
      disabled: false,
      tempData: {},
    };
  },
  created() {},
  async mounted() {
    this.skLoading = true;
    // 上级模块
    try {
      // if (!this.func_disabled && !this.$store.state.iconstatus) {
      //   this.disabled = true
      // }
      await this.national("mrbase_sys_functions");
      const top_module = await getprompt({
        prompt_name: "function_parent",
        uuid: this.detailData.uuid,
      });
      this.top_module = top_module.data;
      // 关联数据表
      const data_table = await getBusinessList("table_name");
      this.data_table = data_table.data;
      // func_type 功能类型
      // 查询功能类型
      const func_type = await getDataByName("functionType");
      this.func_type = func_type.data;
      // 开放以下单位
      const unit_data = await getBusinessList("open_util");
      this.unit_data = unit_data.data;
      // 新增的时候进页面就不传上级模块 获取顶级模块的版本
      // 修改的时候传上级模块 获取版本
      // if (this.detailData.module_uuid) {
      //   const version_data = await get_versions({
      //     module_uuid: this.detailData.module_uuid,
      //   })
      //   this.version_arr = version_data.data.version_uuid
      //     .split(',')
      //     .map((item) => {
      //       return {
      //         value_field: item,
      //         view_fields: item,
      //       }
      //     })
      //   this.version_uuid = version_data.data.uuid
      // }
      this.skLoading = false;
    } catch (error) {
      this.skLoading = false;
    }
  },
  methods: {
    // 新增的时候 上级模块改变  要去改版本
    // 修改的时候 上级模块改变 不修改版本

    // 功能客户端类型根据上级模块来变化
    async moduleChange(val) {
      // 如果是新增就可以修改版本
      this.detailData.client_type_uuid = [];
      this.client_type = [];
      this.detailData.version_uuid = "";
      this.version_arr = [];
      // 功能客户端类型  高级参照
      const client_type = await getprompt({
        prompt_name: "function_client_type",
        module_uuid: val,
      });
      this.client_type = client_type.data;
    },
    handleReturn() {
      this.$router.go(-1);
    },
    handleEdit() {
      this.disabled = !this.disabled;
    },
    // 删除功能
    async handleDel() {
      this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
        .then(async () => {
          const del = await get_func_del({ uuid: this.detailData.uuid });
          if (del.code == 200) {
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
            this.$router.push({
              name: "module_func_manage",
            });
          }
        })
        .catch((err) => {});
    },
    // 取消
    cancel() {
      if (this.detailData.uuid) {
        this.disabled = !this.disabled;
        this.$emit("func_cancel");
      } else {
        this.$router.go(-1);
      }
      // this.$myConfirm({
      //   content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      // })
      //   .then(() => {
      //     if (this.detailData.uuid) {
      //       this.disabled = !this.disabled
      //       this.$emit('func_cancel')
      //     } else {
      //       this.$router.go(-1)
      //     }
      //   })
      //   .catch(() => { })
      // 取消的时候显示修改前的值
    },
    // 确认
    success() {
      // const isSubmit = this.$refs.add_func.validate()
      this.$v.detailData.$touch();
      if (this.$v.detailData.$error) return;
      if (true) {
        const obj = this.$clone(this.detailData);
        // obj.org_level_uuid = obj.org_level_uuid.join()
        obj.client_type_uuid = obj.client_type_uuid.join();
        if (obj.created_utc_datetime) {
          delete obj.created_utc_datetime;
          delete obj.updated_utc_datetime;
        }
        // 修改的值传出去
        this.$emit("getData", obj);
        // 把选择了的客户端类型传给按钮做下拉
        let client_type = [];
        this.client_type.forEach((item) => {
          this.detailData.client_type_uuid.forEach((items) => {
            if (item.value_field == items) {
              client_type.push(item);
            }
          });
        });
        this.$emit("getBtnClientType", client_type);
        this.$emit("getVersion_uuid", this.version_uuid);
      }
    },
  },
  computed: {
    function_button_version() {
      const obj = {
        prompt_name: "function_button_version",
        module_uuid: this.detailData.module_uuid,
        version_uuid: this.detailData.version_uuid,
      };
      return obj;
    },
  },
  watch: {
    // disabled: {
    //   handler (v) {
    //     if (!this.$store.state.uuid) return
    //     if (!v) {
    //       this.$route.meta.title = 'label_edit_module_functions'
    //       this.$store.commit('set_page_title', 'label_edit_module_functions')
    //     }
    //     else {
    //       this.$route.meta.title = 'label_view_module_functions'
    //       this.$store.commit('set_page_title', 'label_view_module_functions')
    //     }
    //   }, immediate: true
    // },
    func_data: {
      handler(val) {
        this.$nextTick(async () => {
          this.disabled = true;
          this.skLoading = true;

          this.successText = this.$t("label_submit");
          const obj = this.$clone(val);
          if (obj.client_type_uuid) {
            obj.client_type_uuid = obj.client_type_uuid.split(",");
          }
          await this.moduleChange(obj.module_uuid);
          this.detailData = obj;
          this.tempData = obj;
          // 修改数据的时候把客户端类型，给按钮使用
          let client_type = [];
          Array.isArray(this.client_type) &&
            this.client_type.forEach((item) => {
              obj.client_type_uuid.forEach((items) => {
                if (item.value_field == items) {
                  client_type.push(item);
                }
              });
            });
          this.$emit("getBtnClientType", client_type);
          this.skLoading = false;
        });
      },
      deep: true,
    },
    func_disabled(val) {
      this.disabled = val;
      this.tempData = this.detailData;
    },
  },
};
</script>

<style scoped></style>
